var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 67,
    viewBox: "0 0 81 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_687_13592)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_13592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 20C8 13.3726 13.3726 8 20 8H81V59H20C13.3726 59 8 53.6274 8 47V20Z",
    fill: "#FF5976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6003 26.6787C31.727 26.798 31.8275 26.9397 31.8961 27.0957C31.9647 27.2517 32 27.419 32 27.5879C32 27.7568 31.9647 27.924 31.8961 28.08C31.8275 28.236 31.727 28.3778 31.6003 28.4971L26.2972 33.5009L31.6003 38.5048C31.8559 38.7459 31.9994 39.073 31.9994 39.414C31.9994 39.755 31.8559 40.0821 31.6003 40.3232C31.3447 40.5643 30.9981 40.6998 30.6367 40.6998C30.2753 40.6998 29.9287 40.5643 29.6732 40.3232L23.3997 34.4037C23.273 34.2844 23.1725 34.1427 23.1039 33.9866C23.0353 33.8306 23 33.6634 23 33.4945C23 33.3256 23.0353 33.1583 23.1039 33.0023C23.1725 32.8463 23.273 32.7046 23.3997 32.5853L29.6732 26.6658C30.1925 26.1757 31.0673 26.1757 31.6003 26.6787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_687_13592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6949 44.4643C47.6404 44.4985 45.925 42.5209 46.3219 40.4799L46.8916 37.1884C46.9771 36.6947 46.8114 36.1906 46.4484 35.84L44.0352 33.509C41.9948 31.5712 43.15 28.0725 45.9321 27.7002L49.2671 27.22C49.7731 27.1471 50.2097 26.8335 50.435 26.3811L51.9265 23.3864C53.1487 20.8734 56.8466 20.8743 58.0682 23.3864L59.5596 26.3811C59.785 26.8335 60.2215 27.1471 60.7275 27.22L64.0625 27.7002C65.6096 27.923 66.7794 29.1119 66.9734 30.6587C67.0378 31.1725 66.6735 31.6413 66.1596 31.7058C65.6456 31.7698 65.177 31.4059 65.1125 30.892C65.0397 30.3112 64.6041 29.673 63.7952 29.5565L60.4602 29.0763C59.3449 28.9157 58.3807 28.2207 57.8809 27.2172L56.3894 24.2225C55.8519 23.0872 54.1425 23.0876 53.6052 24.2225L52.1137 27.2172C51.6139 28.2207 50.6497 28.9157 49.5343 29.0763L46.1994 29.5565C45.5987 29.643 45.1301 30.0351 44.9459 30.6053C44.7645 31.1665 44.9112 31.7477 45.3381 32.1601L47.7513 34.4912C48.5616 35.2739 48.931 36.4017 48.7395 37.5083L48.1698 40.7998C47.9337 42.0402 49.3251 43.0112 50.4232 42.4078L53.4061 40.8537C53.9722 40.5588 54.5663 40.414 55.1248 40.4343C55.3454 40.4425 55.7447 40.5462 55.7771 40.5537C56.2815 40.6709 56.5955 41.1748 56.4782 41.6793C56.361 42.1838 55.8572 42.4977 55.3527 42.3804C55.305 42.3693 55.0786 42.3108 55.0515 42.3082C54.8218 42.2995 54.5511 42.3719 54.2728 42.5169L51.2898 44.071C50.7843 44.3343 50.238 44.4643 49.6949 44.4643ZM65.7809 35.6045C65.7809 33.7431 64.2665 32.2288 62.4052 32.2288C57.9266 32.4142 57.9284 38.7956 62.4052 38.9802C64.2665 38.9802 65.7809 37.4659 65.7809 35.6045ZM63.9055 35.6045C63.9055 36.4318 63.2325 37.1048 62.4052 37.1048C60.4147 37.0224 60.4155 34.1862 62.4052 34.1042C63.2325 34.1042 63.9055 34.7773 63.9055 35.6045ZM66.9999 44.5595C66.9999 42.1581 65.0393 40.2044 62.6293 40.2044H61.9935C59.5835 40.2044 57.6229 42.1581 57.6229 44.5595C57.6229 45.0774 58.0427 45.4972 58.5606 45.4972C59.0785 45.4972 59.4983 45.0774 59.4983 44.5595C59.4983 43.1922 60.6177 42.0798 61.9935 42.0798H62.6293C64.0052 42.0798 65.1245 43.1922 65.1245 44.5595C65.1245 45.0774 65.5443 45.4972 66.0622 45.4972C66.5801 45.4972 66.9999 45.0774 66.9999 44.5595Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_687_13592",
    x: 0,
    y: 0,
    width: 89,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_13592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_13592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_13592"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 20C8 13.3726 13.3726 8 20 8H81V59H20C13.3726 59 8 53.6274 8 47V20Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_687_13592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 24,
    fill: "white",
    transform: "translate(43 21.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.fd56f3f3069d6d933b818bd78dd82a70.svg";
export { ForwardRef as ReactComponent };